import React from 'react'
import loader from '../assets/loader.gif'

export default function Loader() {
  return (
    <>
    <div className="mt-10 mb-10  text-center">
        <img src={loader} alt="Loader Animation" />
    </div>
    </>
  )
}
